import React from "react";

import formatCurrency from "Utils/formatCurrency";

import { Table, TR, NestedTR, TH, TD, HeaderTR } from "Cobalt/TableV2";
import { Div } from "Common/HTML";

export type EmployeeCostsTableProps = {
  rows: Array<{
    name: string;
    age: number;
    cost: number;
    nested: boolean;
  }>;

  emptyComponent?: React.ReactNode;
  children?: React.ReactNode;
};

export const EmployeeCostsTable = ({ rows, emptyComponent, children, ...props }: EmployeeCostsTableProps) => {
  if (!rows.length) {
    return emptyComponent || null;
  }

  return (
    <Div {...props}>
      <Table>
        <thead>
          <HeaderTR>
            <TH>Employee</TH>
            <TH>Age</TH>
            <TH align="right">Cost</TH>
          </HeaderTR>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            const TableRow = row.nested ? NestedTR : TR;
            return (
              <TableRow highlightFirstCell={false} key={`row_${index}`}>
                <TD>{row.name}</TD>
                <TD>{row.age}</TD>
                <TD align="right">{formatCurrency(row.cost, 2)}</TD>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
      {children}
    </Div>
  );
};
